module.exports = __webpack_public_path__ + "static/media/london-13.e1047236.svg";